import { render, staticRenderFns } from "./PollEditor.vue?vue&type=template&id=51fffac1&scoped=true"
import script from "./PollEditor.vue?vue&type=script&lang=js"
export * from "./PollEditor.vue?vue&type=script&lang=js"
import style0 from "./PollEditor.vue?vue&type=style&index=0&id=51fffac1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51fffac1",
  null
  
)

export default component.exports